import styled, {css} from 'styled-components';
import {typographyStyles} from '../../utils/styles';
import {cardTypesConstants} from '../../constants';

const enableLimitClassName = '.enable-limit'

const StyledCreditCardSummary = styled.div`
  border-radius: 16px 16px 0 0;
  font-weight: 700;
  padding: 16px;
  position: relative;
  text-transform: uppercase;
  
  ${props => props.variant === cardTypesConstants.DIGITAL ? css`
    background-color: ${props => props.theme.colors.additional_apple};
    color: ${props => props.theme.colors.neutral_10};
  ` : css`
    background-color: #40B0D5;
    color: ${props => props.theme.colors.neutral_1};
  `}
  
  &${enableLimitClassName} {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

const StyledCreditCardSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledCreditCardSummaryLimit = styled.div`
  background-color: ${props => props.theme.colors.neutral_3};
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  padding: 16px;
  width: 100%;
  
  .ant-progress-line {
    margin-bottom: 0;
  }
`;

const StyledCreditCardSummaryLimitHelper = styled.div`
  ${typographyStyles.body.regular};
  align-items: center;
  color: ${props => props.theme.colors.neutral_8};
  display: flex;
  justify-content: space-between;

  .ant-progress {
    &.ant-progress-status-success {
      background-color: ${props => props.theme.colors.primary_4};
    }
    &.ant-progress-status-exception {
      background-color: ${props => props.theme.colors.functional_danger};
    }
  }
`;

export {
  StyledCreditCardSummary,
  StyledCreditCardSummaryContainer,
  StyledCreditCardSummaryLimit,
  StyledCreditCardSummaryLimitHelper,
}
